import type { SearchCriteria, PartialSearchCriteria } from '../../model/types';

export interface ResortsParams {
  toCity?: string;
}

/**
 * Курорты в параметр `toCity` (join `.`) — только для точечного выбора курортов
 * (`kind: 'resorts'`). Для выбора страны целиком (`kind: 'country'`) каталог
 * курортов лежит в `country.resorts` и это весь список страны, а не фильтр,
 * поэтому `toCity` не выводим (паритет с источником: поиск по стране не несёт
 * точечного набора курортов).
 */
export function resorts(criteria: SearchCriteria | PartialSearchCriteria): ResortsParams {
  const { destination } = criteria;
  if (destination?.kind === 'resorts' && destination?.resorts?.length) {
    return { toCity: destination.resorts.map((resort) => resort.id).join('.') };
  }
  return {};
}
